import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onMounted, ref } from "vue";
import { useOperationStore } from "@/stores/operation";
import { fileExists } from "@/libs/tools";

import "@/idgames/2024-Tecnifibre-209/assets/styles/main.scss";
import "@/idgames/2024-Jacob_Delafon-217/assets/styles/mains.scss";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const operation = useOperationStore();
const currentVueInstance = getCurrentInstance();

const waitForComponent = ref("");

onMounted(async () => {
  try {
    await operation?.getOperation();
    let lang = "fr";

    console.log("---------", operation?.operationData);

    if (operation?.operationData) {
      if (
        operation?.operationData?.langs &&
        operation?.operationData?.langs.length > 0
      ) {
        lang = operation?.operationData?.langs[0];
      } else if (operation?.operationData?.lang) {
        lang = operation?.operationData?.lang;
      }

      const files = operation?.getFilesData;
      let savedLang = "";

      if (
        operation?.operationData?.langs &&
        operation?.operationData?.langs.length > 1
      ) {
        savedLang = localStorage.getItem("lang") ?? lang;
      } else if (
        operation?.operationData?.langs &&
        operation?.operationData?.langs.length === 1
      ) {
        savedLang = operation?.operationData?.langs[0];
      } else {
        savedLang = operation?.operationData?.lang || lang;
      }
      if (
        currentVueInstance &&
        currentVueInstance.proxy &&
        operation &&
        lang !== undefined
      ) {
        currentVueInstance.proxy.$i18n.locale = savedLang ?? lang;

        document.title =
          operation?.operationData?.custom?.pagetitle ?? "......";

        const favicon = fileExists(files as unknown as unknown[], "favicon");
        const linkfav: HTMLLinkElement | null =
          document.querySelector("link[rel='icon']");
        if (linkfav && favicon && favicon.length > 0) {
          linkfav.href = (favicon[0] as { uri: string })?.uri || "/favicon.ico";
        }
      }
    }

    setTimeout(() => {
      //   waitForComponent.value = "Cet identifiant n'est lié à aucune opération";
    }, 1000);
  } catch (error) {
    console.error(error);
  }
});


return { __sfc: true,operation, currentVueInstance, waitForComponent }
}

})